import {useDispatch, useSelector} from "react-redux"
import {
	closeAttachmentModal,
	createNewTipTapDocument, editDocumentAttachment,
	selectActionType, selectIsSubmitting,
	selectNoteAttachmentPreview, updateNoteAttachmentPreview,
} from "../../../../../../reducers/noteAttachmentsSlice"
import {
	Button, DialogActions, DialogContent, DialogContentText, TextField,
} from "@mui/material"
import {useWorkspaceContext} from "../../../../../../pages/Dashboard"

export function DocAttachmentModalBody({note}) {
	const dispatch = useDispatch()
	const { workspaceId } = useWorkspaceContext()
	const attachmentPreview = useSelector((state) => selectNoteAttachmentPreview(state, workspaceId))
	const actionType = useSelector((state) => selectActionType(state, workspaceId))
	const isSubmitting = useSelector((state) => selectIsSubmitting(state, workspaceId))

	return (
		<DialogContent>
			<DialogContentText variant="body1" sx={{color: "black"}} paragraph gutterBottom>
				{
					actionType === "create-doc" && (
						`Enter a title or description for the new document attached on note: ${note?.content}. Otherwise, one will be created for you.`
					)
				}
				{
					actionType === "edit-doc" && (
						`Change the title for the document attached on note: ${note?.content}. This will not affect the contents of the document.`
					)
				}
			</DialogContentText>
			<form onSubmit={(e) => {
				e.preventDefault()
				if (actionType === "create-doc") {
					dispatch(createNewTipTapDocument({ attachment: attachmentPreview, note }))
				}
				if (actionType === "edit-doc") {
					dispatch(editDocumentAttachment({attachment: attachmentPreview, note}))
				}
			}}>
				<TextField
					variant="outlined"
					label={"Title or Description"}
					className="keyTextField"
					value={attachmentPreview?.title}
					placeholder={actionType === "create-doc" ? attachmentPreview?.description : null}
					onChange={(e) => dispatch(updateNoteAttachmentPreview({preview: {...attachmentPreview, title: e.target.value}, workspaceId}))}
					sx={{
						mt: 1, // shorthand for marginTop: theme.spacing(2)
						mb: 2, // shorthand for marginBottom: theme.spacing(2)
					}}
					fullWidth
				/>
				<DialogContentText variant="body1" sx={{color: "black"}} paragraph gutterBottom>
					After clicking {actionType === "create-doc" ? "Create" : "Update"}, the document editor will automatically open in a new tab.
				</DialogContentText>
				<DialogActions
					sx={{
						padding: 0,
						mt: 1
					}}
				>
					<Button
						variant="contained"
						color={"primary"}
						type="submit"
						disabled={isSubmitting}
					>
						{ actionType === "create-doc" && "Create Doc" }
						{ actionType === "edit-doc" && "Update Doc" }
					</Button>
					<Button
						variant={"outlined"}
						color="primary"
						onClick={() => dispatch(closeAttachmentModal(workspaceId))}
					>
						Cancel
					</Button>
				</DialogActions>
			</form>
		</DialogContent>
	)
}